import {format} from 'date-fns';

/**
 * The dateFns locale for the formatting
 * @param {!Object} locale
 * @returns {function((!Date|number), string): string }
 */
const createFormatDate = (locale) => (
	function formatDate(date, dateFormat) {
		return format(
			date,
			dateFormat,
			{
				locale
			}
		);
	}
);

export default createFormatDate;